import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { loader_image } from "../_components/Imagepath";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { useFormik } from "formik";
import $ from "jquery";
import PropTypes from 'prop-types';
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  base_url, Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
let season_id = localStorage.getItem("season_id");

 const formData={
    season_id:season_id,   
 };
const EmployeePaySlipAudit = () => {
  const [menu, setMenu] = useState(false);
  const [dataa, setDataa] = useState([]);
  const [employeesList, setEmployeesList] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [permission, setPermission] = useState({});
  const [locationLoading, setLocationLoading] = useState([]);

  

  useEffect(() => {
        setPermission(FindModuleById(452)); 
        console.log(permission);


                    axios
                    .get(`/helpers/loading-locations`, {
                      headers: {
                        Authorization: `Bearer ${Authtoken}`,
                        Apitoken: Apitoken,
                      },
                    })
                    .then((response) => {
                      if (response.data.code == 200) {
                        let locations = response.data.data.locations;
                        let emp_statusList = locations.map((ord, index) => ({
                          label:  ord.title ,
                          value: ord.id,
                          key: `sts-${index}`,
                        }));
                        
              
                        setLocationLoading(emp_statusList);
                     } else {
                        console.log("API response is not an array");
                      }
                    })
                    .catch((error) => {
                      console.log(error);
                    });
    axios.post("/employees/listing-active-emp-for-salary",{},{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
       
        if (response.data.code === 200) {
          //setEmployeesList(response.data.data.employees);
          let employees = response.data.data.employees;
          let emp_statusList = employees.map((ord, index) => ({
            label:  ord.first_name +' '+ord.last_name + ' ('+ord.emp_status.title+')',
            value: ord.id,
            key: `sts-${index}`,
          }));
          
  
          setEmployeesList(emp_statusList);
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });

      axios.post("/employees/payslip-audit/salary-slips-listing",formData,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
       
        if (response.data.code === 200) {
          setDataa(response.data.data.slips);
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });
      axios.get("/helpers/employees-status", {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if(response.data.code === 200){
          let emp_status = response.data.data.emp_status;
         // setPackagingTypesLists(materials_payment_status);
          let emp_statusList = emp_status.map((ord, index) => ({
            label:  ord.title ,
            value: ord.id,
            key: `sts-${index}`,
          }));
          setStatusOptions(emp_statusList);
      }else{
          console.log("API response is not an array");
        }
                
      })
      .catch((error) => {
        console.log(error);
      });

  }, []);



  const {
    values,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
       season_id:season_id,
      employee_type:"",
      location:"",
      shift:'',
      employee: [],  // ✅ Must be an array for multiple selection
      start_date: "",
      end_date: "",
    
    },
    onSubmit: (values, actions) => {
      axios
        .post("/employees-payslip-audit-generate-all-salary", values, {
          responseType: 'blob',
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
              const blob = new Blob([response.data], { type: 'application/pdf' });
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              const matchedLabels = employeesList .filter(item => values.employee.includes(item.value)).map(item => item.label);
              const namesString = matchedLabels.join(", ");
              let file_name = namesString+' '+values.start_date+' '+values.end_date+ '.pdf';
              link.download = file_name // Ensure this matches your desired file name
              document.body.appendChild(link); // Append to the body to work in some browsers
              link.click();
              document.body.removeChild(link); // Clean up after download
          
             actions.setSubmitting(false);
             $("#form-submit").text("Generate");
        })
        .catch((error) => {
          actions.setSubmitting(false);
          console.log(error)
        });
    },
  });
const shiftlist = [
  { value: 1, label: "Shift 1" },
  { value: 2, label: "Shift 2" }
];
  
  const DownloadSlip = async (employee) => {
   
   var emp  = employee.employee;
   console.log(employee);
   let file_name = emp.first_name + ' '+emp.last_name + ' '+employee.end_date +'.pdf'; 
  console.log(file_name);
    $("#loader-image-"+employee.id).removeClass('loader-hide');
    $("#loader-image-"+employee.id).addClass('loader-show');
    try {
      let season_id = localStorage.getItem("season_id");
         await axios.get(`/employees-payslip-audit-salary-slip-download/${season_id+'-'+employee.id}`, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        
      }) .then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = file_name // Ensure this matches your desired file name
        document.body.appendChild(link); // Append to the body to work in some browsers
        link.click();
        document.body.removeChild(link); // Clean up after download
        
       // setBackendSuccess(response.data.message);
       // toast.success(response.data.message);
       // actions.resetForm();
      //  actions.setSubmitting(false);
      //  $("#form-submit").text("Generate Pay Slip");
       $("#loader-image-"+employee.id).addClass('loader-hide');
       $("#loader-image-"+employee.id).removeClass('loader-show');
      })

  } catch (error) {
    console.error(error);
  }

  }


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


const customHandleInput = (event) => {
  console.log(event);
  //const Input_name = event.target.name;
  //delete backendErrors[Input_name];
};

// const handleChangeDate = (date) => {
//   setDate(date);
// };

const ActionColumn = ({ row }) => {
  return (
    <div>
      <button
        className="btn btn-primary btn-block"
        id={`button-all-${row.original.id}`}
        onClick={() => DownloadSlip(row.original)}
      >
        Download Slip
        <img
          id={`loader-image-${row.original.id}`}
          className="loader-image loader-hide"
          src={loader_image} // Ensure this is defined
          alt="loading"
        />
      </button>
    </div>
  );
};

// ✅ Define PropTypes for ActionColumn
ActionColumn.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
  }).isRequired,
};

// ✅ Define ActionCell as a separate component
const ActionCell = ({ row }) => <ActionColumn row={row} />;

// ✅ Define PropTypes for ActionCell
ActionCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
  }).isRequired,
};

const columnss = [
  {
    header: 'Employee Name',
    accessorFn: (row) =>
      row.employee ? `${row.employee.first_name} ${row.employee.last_name}` : '',
  },
  {
    header: 'Employee Position',
    accessorFn: (row) => (row.employee ? row.employee.position : ''),
  },
  {
    header: 'Salary Duration',
    accessorFn: (row) => `${row.start_date} to ${row.end_date}`,
  },
  { accessorKey: 'net_earning', header: 'Net Earning' },
  { accessorKey: 'shift_hour', header: 'Total of hours' }, 
  // { accessorKey: 'extra_hour', header: 'Extra Hour' },
  {
    header: 'Payment Method',
    accessorFn: (row) => (row.employee ? row.employee.payment_method : ''),
  },
  {
    header: 'ACTION',
    Cell: ActionCell, // ✅ Pass the validated component directly
  },
];



   const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    setFieldValue(name, value);
  };

  //console.log(event);
  const formfilterRef = useRef({
  season_id: season_id,
  cnss: 1,
});
const customHandleStatus = (event) => {
  formfilterRef.current = {
    ...formfilterRef.current,   // purana data preserve
    emptype: event?.value || "", 
  };
  fetchEmployees(formfilterRef.current);
};

const customHandleShift = (event) => {
  formfilterRef.current = {
    ...formfilterRef.current,   // purana data preserve
    shift: event?.value || "", 
  };
  fetchEmployees(formfilterRef.current);
};
const customHandleLocation = (event) => {
  formfilterRef.current = {
    ...formfilterRef.current,   // purana data preserve
    location: event?.value || "", 
  };
  fetchEmployees(formfilterRef.current);
};

  const fetchEmployees = (filter) => {
  axios.post("/employees/listing-active-emp-for-salary", filter, {
    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  })
  .then((response) => {
    if (response.data.code === 200) {
      let employees = response.data.data.employees;
      let emp_statusList = employees.map((ord, index) => ({
        label: `${ord.first_name} ${ord.last_name} (${ord.emp_status.title})`,
        value: ord.id,
        key: `sts-${index}`,
      }));
      setEmployeesList(emp_statusList);
    } else if (response.data.code === 401) {
      window.location.href = "/login";
    } else {
      window.location.href = "/login";
    }
  })
  .catch((error) => {
    console.log(error);
  });
};
function objectToQueryString(obj) {
  return Object.keys(obj)
    .map(key => {
      if (Array.isArray(obj[key])) {
        return obj[key]
          .map(val => encodeURIComponent(key + '[]') + '=' + encodeURIComponent(val))
          .join('&');
      }
      return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
    })
    .join('&');
}
 const downloadExcel = (e) => {

    console.log(e);
    const queryString = objectToQueryString(values);    
    window.open(`${base_url}/employees/export-working-hours-audit?${queryString}`, '_blank');
  }
console.log(locationLoading);

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title"> Payslip Audit</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active"> Payslip Audit</li>
                </ul>
              </div>
            
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body" > 
                   <form action="#" onSubmit={handleSubmit} style={{padding:'30px'}}>
                    <h4 className="card-title"> Payslip Audit</h4><br/>
                   
                      <div className="row" >
                      <div className="col-md-2">
                          <div className="form-group">
                            <label>Select Employee Type</label>
                              <Select
                                className="w-100"
                                value={statusOptions.find(option => option.value == values.employee_type) || null} // Ensure correct format
                                name="employee_type"
                                  //onChange={(selectedOption) => handleSelectChange("employee_type", selectedOption)}
                                  onChange={(selectedOption) => {
                                    handleSelectChange("employee_type", selectedOption);
                                    customHandleStatus(selectedOption);
                                  }}
                                onBlur={handleBlur}
                                options={statusOptions}
                                placeholder="Select"
                              />

                            </div>
                        </div>
                         <div className="col-md-3">
                            <div className="form-group">
                              <label>Select Location:</label>
                              <Select
                                  options={locationLoading}
                                  name="location"
                                  value={locationLoading.find(option => option.value == values.location) || null} 
                                  //onChange={(selectedOption) => handleSelectChangeOrder(selectedOption)}
                                  onChange={(selectedOption) => {
                                    handleSelectChange("location", selectedOption);
                                    customHandleLocation(selectedOption);
                                  }}
                                />
                            </div>
                          </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label>Select Employee</label>
                              <Select
                                 className="w-100"
                                 value={employeesList.filter(option => values.employee.includes(option.value))} // Ensure correct selection
                                 name="employee"
                                 onChange={(selectedOptions) => {
                                   const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                   setFieldValue("employee", selectedValues); // ✅ Ensure correct update in Formik state
                                 }}
                                 onBlur={handleBlur}
                                 options={employeesList}
                                 placeholder="Select"
                                 isMulti
                                />

                            </div>
                        </div>
                          <div className="col-md-1">
                            <div className="form-group">
                              <label>Select Shift</label>
                                <Select
                                    className="w-100"
                                    value={shiftlist.find(option => option.value === values.shift) || null}

                                    name="shift"
                                  onChange={(selectedOption) => {
                                      handleSelectChange("shift", selectedOption);
                                      customHandleShift(selectedOption);
                                    }}
                                    onBlur={handleBlur}
                                    options={shiftlist}
                                    placeholder="Select"
                                  
                                  />
  
                              </div>
                          </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <label>Start Date</label>
                            <input
                              type="date"
                              name="start_date"
                              value={values.start_date}
                              className='form-input form-control'
                             required
                              onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              //  setDefaultDate(e.target.value)
                              }}
                               onBlur={handleBlur}
                            />
                        
																
                          </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                              <label>End Date</label>
                              <input
                                type="date"
                                name="end_date"
                                value={values.end_date}
                                className="form-input form-control"
                                required
                                min={values.start_date || ""} // ✅ Prevent selecting earlier dates
                                onChange={(e) => {
                                  // Ensure End Date >= Start Date
                                  if (values.start_date && e.target.value < values.start_date) {
                                    alert("End Date cannot be earlier than Start Date");
                                    return;
                                  }
                                  handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={handleBlur}
                              />
                            </div>
                          </div>
                       <div className="col-md-1">
                          <div className="text-end mt-4">
                              <button  style={{float:"right"}} className="btn btn-primary" onClick={() => downloadExcel()} >
                                    work time tracking Audit<i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i>
                                  </button>
                          </div>
                       </div>
                       <div className="col-md-1">
                          <div className="text-end mt-4">
                            <button
                              type="submit" id="form-submit"
                              className="btn btn-primary"
                              disabled={isSubmitting}
                            >
                              Generate 
                              <img id="loader-image" className="loader-image loader-hide" src={loader_image}/>
                            </button>
                          </div>
                       </div>
                     
                       
                     
                      </div>
                   
                      
                   
                    </form>
                 
                </div>
              </div>
            </div>
          </div>

          
          <div className="row">
            <div className="col-sm-12">
              {permission && permission.list == 1 && ( 
                <div className="card card-table" style={{padding:'30px'}}>
                  <div className="card-body" > 
                    <h4 className="card-title">Payslip Audit Listing</h4>
                      <div className="row">
                        <div className="col-sm-12">
                        <div className="table-responsive">
                            <MaterialReactTable columns={columnss} data={dataa} 
                                enableColumnOrdering
                                enablePinning
                              
                              />
                            </div>
                        </div>
                      </div>
                  
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EmployeePaySlipAudit;
